import React from 'react'

import Navigation from '../Navigation/Navigation'

import { store } from '../../store'

import Menu from '../Navigation/Menu'

import Footer from '../Footer/Footer'

import Rolling from '../../Images/rolling.svg';

class Verify extends React.Component {
constructor(props) {
	super(props)
	this.state = {
		status: '',
		error: false
	}
}
sendmail = () => {
	this.setState({status: 'processing'})
	fetch(`${process.env.REACT_APP_API}/sendverificationmail`, {
      method: 'post',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({
      user: {
      	username: store.getState().user.user.username
        },
      token: store.getState().user.token
    })
    })
      .then(response => {
      	response.json()
      	.then(data=> {
      		if(data.Email === 'Sent') {
      			this.setState({status: 'success'})
      		}
      		else {
      			this.setState({error: true})
      		}
      	})

      })
}

render(props) {
		let { onMenu, menuState, onClickInside, onClickOutside, onRouteChange, onOpen, isDashboard} = this.props
		let user = store.getState().user.user
		return (
			<div className="dash_bg">
			<div className="dash_nav">
			<Navigation 
	         onMenu={onMenu}
	         menuState={menuState}
	         onClickInside={onClickInside}
	         onClickOutside={onClickOutside}/>
	         </div>
			<div className="form">
			{this.state.status === 'success'
			? <h4>Email Successfully sent!</h4>
			: null
			}
			<h4>Hello <strong>{user.username}</strong>, your account is almost ready. Please click & <strong>verify your account</strong> with the link we've sent to your email (<strong>{user.email}</strong>). Make profile pages simple, thank you! <i class="em em-slightly_smiling_face"></i></h4>
			<button onClick={this.sendmail.bind()} className="top_btn">
	        {this.state.status === 'processing'
	      	?<span className="rolling"><img src={Rolling} className="rolling_img" alt="rolling"/></span>
	      	: null
	 		}
	 		{this.state.status === '' || this.state.status === 'success'
	      	?<span>Resend Mail</span>
	      	: null
	 		}
	        </button>
			</div>
			<Footer />
			{store.getState().activities.open === 'menu'
            ? <Menu
            onClickInside={onClickInside}
            onClickOutside={onClickOutside}
            onRouteChange={onRouteChange}
            onOpen={onOpen}
            isDashboard={isDashboard} />
            : null
          }
			</div>
			)
	}
}

export default Verify